import {
  DETAIL_TRANSACTIONS_NETPAY,
  DETAIL_TRANSACTIONS_ERROR,
  CLEAN_DETAIL_TRANSACTIONS_NETPAY,
  CLEAN_DETAIL_TRANSACTIONS_NETPAY_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  response: undefined,
  status: undefined,
  state: undefined,
};

export default function detailTransactionsNetpayReducer(state = initialState, action) {
  switch (action.type) {
    case DETAIL_TRANSACTIONS_NETPAY:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'success',
      };

    case DETAIL_TRANSACTIONS_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DETAIL_TRANSACTIONS_NETPAY:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DETAIL_TRANSACTIONS_NETPAY_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
